<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title fxFlex="0 0 auto">
        <span>{{ title }}</span>
        <mat-icon class="icon" *ngIf="showIcon" [color]="iconcolor">{{ iconname }}</mat-icon>
    </h1>
    <div fxFlex="1 1 auto" [class.scrolly]="SmallDisplay" [class.hidescrollx]="SmallDisplay">
        <!-- #region Wide Display Stepper -->
        <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px" class="height100">
            <!-- #region Top content area -->
            <div fxFlex fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="35px" class="height100">
                <!-- #region Vertical Step Strip -->
                <div *ngIf="!SmallDisplay" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
                    <button
                        type="button"
                        *ngFor="let btn of AllSteps; let idx = index"
                        mat-flat-button
                        [color]="btn.Active ? 'accent' : 'primary'"
                        [disabled]="!btn.Valid"
                        (click)="SetCurrentStep(idx)"
                    >
                        {{ btn.Text }}
                    </button>
                </div>
                <!-- #endregion -->
                <!-- #region Content Area -->
                <div fxFlex [class.scrolly]="!SmallDisplay" [class.hidescrollx]="!SmallDisplay">
                    <div>
                        <div [hidden]="CurrentStep?.value !== 0">
                            <p>
                                You may use this wizard to {{ IsUpdate ? 'update an ' : 'create a new ' }} "Out of Office" designation
                                in the IRIS sytem. If you wish to cancel this operation at any time, click the "Cancel" button in the
                                lower-right corner of this popup.
                            </p>
                            <p>
                                Which of the following methods would you like to use to choose the person you wish to designate as your
                                "Out of Office" handler?
                            </p>
                            <div class="choices">
                                <mat-radio-group
                                    [formControl]="SelectionTypeInfo?.get('Type')"
                                    fxLayout="column"
                                    fxLayoutAlign="start stretch"
                                    fxLayoutGap="15px"
                                >
                                    <mat-radio-button value="subordinate"
                                        >I'd like to select from a list of my subordinates.</mat-radio-button
                                    >
                                    <mat-radio-button value="district"
                                        >I'd like to search for a district staff member.</mat-radio-button
                                    >
                                </mat-radio-group>
                            </div>
                        </div>
                        <div [hidden]="CurrentStep?.value !== 1">
                            <div
                                [hidden]="SelectionTypeInfo?.get('Type')?.value !== 'subordinate'"
                                fxLayout="column"
                                fxLayoutAlign="start stretch"
                            >
                                <p>
                                    Using the dropdown list provided below, select the subordinate employee you would like to designate
                                    as your "Out of Office" handler.
                                </p>
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxLayoutGap="15px"
                                    fxLayout.lt-md="column"
                                    fxLayoutAlign.lt-md="start stretch"
                                >
                                    <div>Subordinates:</div>
                                    <mat-form-field appearance="outline" fxFlex>
                                        <mat-select
                                            matInput
                                            [formControl]="RecipientInfo?.get('User')"
                                            placeholder="Select subordinate..."
                                        >
                                            <mat-option [value]="null">Select subordinate...</mat-option>
                                            <mat-option *ngFor="let sub of subordinates" [value]="sub"
                                                >{{ sub.FirstName | titleCase }} {{ sub.LastName | titleCase }} ({{
                                                    sub.LocalJobTitle
                                                }})</mat-option
                                            >
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div
                                [hidden]="SelectionTypeInfo?.get('Type')?.value !== 'district'"
                                fxLayout="column"
                                fxLayoutAlign="start stretch"
                            >
                                <p>
                                    Using the search fields provided below, search for a district staff member that you would like to
                                    designate as your "Out of Office" handler.
                                </p>
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxLayoutGap.gt-sm="15px"
                                    fxLayout.lt-md="column"
                                    fxLayoutAlign.lt-md="start stretch"
                                >
                                    <mat-form-field appearance="outline">
                                        <input
                                            type="text"
                                            matInput
                                            [formControl]="SearchParams?.get('LastName')"
                                            placeholder="Last Name..."
                                            (keyup.enter)="HandleUserSearch()"
                                            #lastname
                                        />
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <input
                                            type="text"
                                            matInput
                                            [formControl]="SearchParams?.get('FirstName')"
                                            placeholder="First Name..."
                                            (keyup.enter)="HandleUserSearch()"
                                        />
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <input
                                            type="text"
                                            matInput
                                            [formControl]="SearchParams?.get('SAPID')"
                                            placeholder="SAPID..."
                                            maxlength="8"
                                            (keyup.enter)="HandleUserSearch()"
                                            #sapid
                                        />
                                        <mat-hint align="start" *ngIf="!SearchParams?.get('SAPID')?.hasError('pattern')"
                                            >Numeric values only</mat-hint
                                        >
                                        <mat-error align="start" *ngIf="SearchParams?.get('SAPID')?.hasError('pattern')"
                                            >Numbers only, please.</mat-error
                                        >
                                    </mat-form-field>
                                </div>
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="center center"
                                    fxLayoutGap="15px"
                                    fxLayout.lt-md="column"
                                    fxLayoutAlign.lt-md="start stretch"
                                >
                                    <button type="button" mat-raised-button color="warn" (click)="ResetForm()">Reset</button>
                                    <button
                                        type="button"
                                        mat-raised-button
                                        color="primary"
                                        [disabled]="!SearchParams.valid"
                                        (click)="HandleUserSearch()"
                                    >
                                        Search
                                    </button>
                                </div>
                                <div [hidden]="!UserSearchConducted" #scrollpanel>
                                    <table mat-table class="fullwidth" [dataSource]="ResultsData" matSort matSortActive="LastName">
                                        <ng-container matColumnDef="LastName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Last Name</th>
                                            <td mat-cell *matCellDef="let user">
                                                <span>{{ user.LastName | titleCase }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="FirstName">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">First Name</th>
                                            <td mat-cell *matCellDef="let user">
                                                <span>{{ user.FirstName | titleCase }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="SAPID">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">SAPID</th>
                                            <td mat-cell *matCellDef="let user">
                                                <span>{{ user.SAPID }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="PositionNo">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Position #</th>
                                            <td mat-cell *matCellDef="let user">
                                                <span>{{ user.PositionNo }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="LocalJobTitle">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Title</th>
                                            <td mat-cell *matCellDef="let user">
                                                <span>{{ user.LocalJobTitle }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="Email">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                                            <td mat-cell *matCellDef="let user">
                                                <span>{{ user.Email }}</span>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="Actions">
                                            <th mat-header-cell *matHeaderCellDef>Action(s)</th>
                                            <td mat-cell *matCellDef="let user">
                                                <button type="button" mat-raised-button color="primary" (click)="SelectUser(user)">
                                                    Select
                                                </button>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="NoData">
                                            <th mat-header-cell *matHeaderCellDef></th>
                                            <td mat-cell *matCellDef="let user" [attr.colspan]="VisibleHeaders.length">
                                                <em>No search results were found with the provided search criteria.</em>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="SmallDisplay">
                                            <th mat-header-cell *matHeaderCellDef>Search Result(s)</th>
                                            <td mat-cell *matCellDef="let user">
                                                <div fxLayout="column" fxLayoutAlign="start stretch" class="margin-bottom">
                                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                                        <strong>First Name:</strong> <span>{{ user.FirstName | titleCase }}</span>
                                                    </div>
                                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                                        <strong>Last Name:</strong> <span>{{ user.LastName | titleCase }}</span>
                                                    </div>
                                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                                        <strong>SAPID:</strong> <span>{{ user.SAPID }}</span>
                                                    </div>
                                                    <div fxLayout="row" fxLayoutAlign="space-between start">
                                                        <strong>Position #:</strong> <span>{{ user.PositionNo }}</span>
                                                    </div>
                                                    <div fxLayout="column" fxLayoutAlign="start stretch">
                                                        <strong>Title:</strong> <span>{{ user.LocalJobTitle }}</span>
                                                    </div>
                                                    <div fxLayout="column" fxLayoutAlign="start stretch">
                                                        <strong>Email:</strong> <span>{{ user.Email }}</span>
                                                    </div>
                                                    <!-- Action button(s) -->
                                                    <button type="button" mat-raised-button color="primary" (click)="SelectUser(user)">
                                                        Select
                                                    </button>
                                                </div>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="VisibleHeaders"></tr>
                                        <tr
                                            mat-row
                                            *matRowDef="let row; columns: VisibleColumns; let $even = even"
                                            [class.primarybackground50]="
                                                $even && RecipientInfo?.get('User')?.value?.SAPID !== row?.SAPID
                                            "
                                            [class.accentbackground50]="RecipientInfo?.get('User')?.value?.SAPID === row?.SAPID"
                                        ></tr>
                                    </table>

                                    <mat-paginator [pageSizeOptions]="[3, 5, 10, 20]" [pageSize]="3"></mat-paginator>
                                </div>
                            </div>
                        </div>
                        <div [hidden]="CurrentStep?.value !== 2">
                            <p>
                                Use the spaces provided below to determine the date ranges when this "Out of Office" designation will
                                be in effect. If you wish for the designation to be continually in effect (non-expiring), you may leave
                                the Ending Date field empty. Note: You may click on the calendar icon to open a calendar selection
                                tool.
                            </p>
                            <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxLayoutGap.gt-sm="15px"
                                    fxLayout.lt-md="column"
                                    fxLayoutAlign.lt-md="start stretch"
                                >
                                    <app-form-label>Beginning Date:</app-form-label>
                                    <mat-form-field appearance="outline">
                                        <input
                                            type="text"
                                            matInput
                                            #datebegininput
                                            [formControl]="DatesInfo?.get('DateBegin')"
                                            [matDatepicker]="beginpicker"
                                        />
                                        <mat-datepicker-toggle matSuffix [for]="beginpicker"></mat-datepicker-toggle>
                                        <mat-datepicker #beginpicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxLayoutGap.gt-sm="15px"
                                    fxLayout.lt-md="column"
                                    fxLayoutAlign.lt-md="start stretch"
                                >
                                    <app-form-label>Ending Date:</app-form-label>
                                    <mat-form-field appearance="outline">
                                        <input
                                            type="text"
                                            matInput
                                            [formControl]="DatesInfo?.get('DateEnd')"
                                            [matDatepicker]="endpicker"
                                        />
                                        <mat-hint align="start">Leave empty for non-expiring designation</mat-hint>
                                        <mat-datepicker-toggle matSuffix [for]="endpicker"></mat-datepicker-toggle>
                                        <mat-datepicker #endpicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <mat-checkbox [formControl]="DatesInfo?.get('Active')"
                                    >Set this "Out of Office" designation as active.</mat-checkbox
                                >
                            </div>
                        </div>
                        <div [hidden]="CurrentStep?.value !== 3">
                            <p>
                                Use the checkboxes below to select which categories this "Out of Office" designation will have access
                                to. If you wish for the designation to have access to all categories you are the cabinet member for,
                                click the "Select All" button.
                            </p>
                            <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                                <div
                                    fxLayout="row"
                                    fxLayoutAlign="start center"
                                    fxLayoutGap="15px"
                                    fxLayoutAlign.lt-md="center center"
                                >
                                    <button type="button" mat-raised-button color="primary" (click)="SelectAllCategories()">
                                        Select All
                                    </button>
                                    <button type="button" mat-raised-button color="accent" (click)="UnselectAllCategories()">
                                        Clear All
                                    </button>
                                </div>
                                <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
                                    <mat-checkbox
                                        *ngFor="let catgp of CategoriesInfo?.controls"
                                        [formControl]="catgp?.get('Selected')"
                                        >{{ catgp?.get('Description')?.value }}</mat-checkbox
                                    >
                                </div>
                            </div>
                        </div>
                        <div [hidden]="CurrentStep?.value !== 4">
                            <p>
                                You are about to {{ IsUpdate ? 'update ' : 'create ' }}the following "Out of Office" designation.
                                Please review the following settings carefully:
                            </p>
                            <div>
                                <strong>Designee: </strong>{{ RecipientInfo?.get('User')?.value?.FirstName | titleCase }}
                                {{ RecipientInfo?.get('User')?.value?.LastName | titleCase }} ({{
                                    RecipientInfo?.get('User')?.value?.LocalJobTitle
                                }})
                            </div>
                            <div><strong>Beginning Date: </strong>{{ DatesInfo?.get('DateBegin')?.value | date: 'M/d/yy' }}</div>
                            <div>
                                <strong>Ending Date: </strong>
                                <span *ngIf="DatesInfo?.get('DateEnd')?.value">{{
                                    DatesInfo?.get('DateEnd')?.value | date: 'M/d/yy'
                                }}</span>
                                <span *ngIf="!DatesInfo?.get('DateEnd')?.value">N/A (Open)</span>
                            </div>
                            <div>
                                <strong>Set as active? </strong><span>{{ DatesInfo?.get('Active')?.value | yesNo }}</span>
                                <div><strong>Categories: </strong></div>
                                <ng-container *ngFor="let catgp of CategoriesInfo?.controls">
                                    <div class="margin-left" *ngIf="catgp.get('Selected')?.value === true">
                                        {{ catgp.get('Description')?.value }}
                                    </div>
                                </ng-container>
                                <div class="margin-top">
                                    Once {{ IsUpdate ? 'updated' : 'created' }}, this "Out of Office" designation will be in effect,
                                    and the designated individual shown above will have access to requests forwarded to you during the
                                    date interval shown above. Click the "{{ IsUpdate ? 'Update' : 'Create' }} Designation" button to
                                    {{ IsUpdate ? 'update' : 'create' }} this designation, or click the "Cancel" button to cancel this
                                    operation.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- #endregion -->
            </div>
            <!-- #endregion -->
        </div>
        <!-- #endregion -->
        <!-- <div [hidden]="!SmallDisplay" fxLayout="column" fxLayoutAlign="start stretch"> -->
        <!-- #region Step 0: Selection Type -->
        <!-- <div [hidden]="CurrentStep?.value !== 0" fxLayout="column" fxLayoutAlign="start stretch">
                <div class="mat-h4">Designee Selection Type</div>

            </div> -->
        <!-- #endregion -->
        <!-- </div> -->
    </div>
    <!-- #region Bottom Navigation Area (Wide Display) -->
    <div
        *ngIf="!SmallDisplay"
        class="padding-top light-gray-top-border"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxFlex="0 0 auto"
    >
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <button type="button" mat-raised-button color="primary" (click)="UpdateStep(-1)" [disabled]="CurrentStep?.value === 0">
                Previous
            </button>
            <button
                type="button"
                *ngIf="CurrentStep?.value !== AllSteps.length - 1"
                mat-raised-button
                color="primary"
                (click)="UpdateStep(1)"
                [disabled]="!AllSteps[CurrentStep?.value + 1].Valid"
            >
                Next
            </button>
            <button
                type="button"
                *ngIf="CurrentStep?.value === AllSteps.length - 1"
                [disabled]="SearchForm?.invalid"
                mat-raised-button
                color="accent"
                (click)="OKHandler()"
            >
                {{ oktext }}
            </button>
        </div>
        <button mat-raised-button color="warn" (click)="Cancel()">
            <span>{{ canceltext }}</span>
        </button>
    </div>
    <!-- #region Bottom Navigation Area (Small Display) -->
    <div
        *ngIf="SmallDisplay"
        class="light-gray-top-border flex-wrap-margins"
        fxLayout="row wrap"
        fxLayoutAlign="center center"
        fxLayoutGap="10px"
        fxFlex="0 0 auto"
    >
        <button type="button" mat-raised-button color="primary" (click)="UpdateStep(-1)" [disabled]="CurrentStep?.value === 0">
            Previous
        </button>
        <button
            type="button"
            *ngIf="CurrentStep?.value !== AllSteps.length - 1"
            mat-raised-button
            color="primary"
            (click)="UpdateStep(1)"
            [disabled]="!AllSteps[CurrentStep?.value + 1].Valid"
        >
            Next
        </button>
        <button
            type="button"
            *ngIf="CurrentStep?.value === AllSteps.length - 1"
            [disabled]="SearchForm?.invalid"
            mat-raised-button
            color="accent"
            (click)="OKHandler()"
        >
            {{ oktext }}
        </button>
        <button mat-raised-button color="warn" (click)="Cancel()">
            <span>{{ canceltext }}</span>
        </button>
    </div>
    <!-- #endregion -->
</div>
